import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

const useStyles = makeStyles(() => ({
  textField: {
    '& input': {
      color: '#222222 !important',
    },
  },
}));

export default function AutoCompleteFilter(props) {
  const classes = useStyles();
  //const options = props.options.map((v) => v?.toString());

  const [value, setValue] = React.useState(props.value ? props.value : '');
  const [inputValue, setInputValue] = React.useState('');
  const [options, setOptions] = React.useState([]);

  React.useEffect(() => {
    if (props.value === '' || props.value === undefined) {
      setPropsValue('');
      setInputValue('');
      setValue('');
    }
    // eslint-disable-next-line
  }, [props.value]);

  const setPropsValue = (value) => {
    props.onChange({
      currentTarget: {
        name: props.name,
        value: value,
      },
    });
  };

  return (
    <div>
      <Autocomplete
        freeSolo={props.freeSolo}
        value={value}
        onChange={(_, value) => {
          setValue(value);
          setPropsValue(value ? value : '');
        }}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue.toUpperCase());
        }}
        getOptionLabel={(option) => {
          if (!option) {
            return '';
          } else if (props.filterType === 'note') {
            const regex = /(<([^>]+)>)/gi;
            option = option?.replace(regex, '  ');
            option = option.replace(/\s{2,}/g, ' ').trim();
            if (option.length > 50) {
              option = option.substring(0, 50) + '...';
            }
            return option;
          } else if (props.filterType == 'list') {
            const data = option.split(props.listSeparator);
            const items = [];
            let newOption = '';
            for (const item of data) {
              if (!items.includes(item) && item.trim() !== '') {
                items.push(item);
              }
            }
            items.map((item) => {
              newOption = newOption + item + ', ';
            });

            newOption = newOption + ',';
            newOption = newOption.replace(', ,', '');

            option = newOption;
          }
          return option;
        }}
        getOptionSelected={(option, value) => {
          return option === value;
        }}
        onOpen={(e) => {
          setOptions(props.options.map((v) => v?.toString()));
        }}
        options={options}
        renderInput={(params) => (
          <TextField
            {...params}
            className={classes.textField}
            label={props.label}
            InputLabelProps={{ shrink: true }}
          />
        )}
      />
    </div>
  );
}
